import React from "react";
import styled, { keyframes } from "styled-components";
import { font } from "./tokens";

const slide = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`;

const Band = styled.div`
  overflow: hidden;
  white-space: nowrap;
  pointer-events: none;
  user-select: none;
`;

const Strip = styled.div<{ $duration: number; $reverse?: boolean }>`
  display: inline-flex;
  align-items: baseline;
  will-change: transform;
  animation: ${slide} ${(p) => p.$duration}s linear infinite;
  animation-direction: ${(p) => (p.$reverse ? "reverse" : "normal")};

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const Word = styled.span`
  font-family: ${font.display};
  font-size: clamp(44px, 6.5vw, 104px);
  font-weight: 400;
  line-height: 1;
  letter-spacing: 0.01em;
  text-transform: uppercase;
  color: transparent;
  -webkit-text-stroke: 1.5px rgba(14, 14, 12, 0.32);
  padding-right: clamp(28px, 3vw, 56px);
`;

const Dot = styled.span`
  font-family: ${font.mono};
  font-size: 18px;
  color: rgba(14, 14, 12, 0.4);
  padding-right: clamp(28px, 3vw, 56px);
`;

/**
 * Infinite outlined-type marquee band. Transform-only CSS animation;
 * static under prefers-reduced-motion.
 */
const Marquee: React.FC<{
  items: string[];
  duration?: number;
  reverse?: boolean;
  className?: string;
}> = ({ items, duration = 30, reverse, className }) => {
  const run = [...items, ...items];
  return (
    <Band className={className} aria-hidden>
      <Strip $duration={duration} $reverse={reverse}>
        {run.map((item, i) => (
          <React.Fragment key={`${item}-${i}`}>
            <Word>{item}</Word>
            <Dot>·</Dot>
          </React.Fragment>
        ))}
      </Strip>
    </Band>
  );
};

export default Marquee;
